<template>
  <v-card class="mb-4">
    <v-toolbar height="47px" color="teal lighten-3" dark>
      <v-toolbar-title>Theme Widget configurations</v-toolbar-title>
    </v-toolbar>
    <v-list two-line>
      <v-layout row justify-space-between align-center class="pa-2" no-gutters>
        <div class="profile-changing">Change Your Widget</div>
        <v-dialog v-model="changeColors" width="100%" @close="changeColors = false" right>
          <template #activator="{ on }">
            <v-btn v-on="on" color="teal lighten-3">Customize</v-btn>
          </template>
          <v-card width="400" style="position: absolute; right: 5px; bottom: 20px">
            <v-card-title class="headline cyan" primary-title> Customizing </v-card-title>
            <v-card-text
              class="widget-customize"
              :style="{
                height: openColorsDialog ? '370px' : 'auto',
              }"
            >
              <v-layout row justify-space-between align-center>
                <span>Background Color</span>
                <swatches
                  v-model="color"
                  @input="saveColors()"
                  @open="openColorsDialog = true"
                  @close="openColorsDialog = false"
                  popover-to="left"
                  row-length="6"
                  show-border
                  :colors="colors"
                />
              </v-layout>
              <br />
              <v-layout row justify-space-between align-center>
                <span>Header Title Color</span>
                <swatches
                  @input="saveColors()"
                  v-model="headerTitleColor"
                  @open="openColorsDialog = true"
                  @close="openColorsDialog = false"
                  popover-to="left"
                  row-length="6"
                  show-border
                  :colors="colors"
                />
              </v-layout>
              <br />
              <v-layout row justify-space-between align-center>
                <span>Background Button Color</span>
                <swatches
                  @input="saveColors()"
                  v-model="buttonColor"
                  @open="openColorsDialog = true"
                  @close="openColorsDialog = false"
                  popover-to="left"
                  row-length="6"
                  show-border
                  :colors="colors"
                />
              </v-layout>
              <br />
              <v-layout row justify-space-between align-center>
                <span>Background Color for timing block</span>
                <swatches
                  v-model="backgroundForTiming"
                  style="max-width: 200px !important"
                  @input="saveColors()"
                  @open="openColorsDialog = true"
                  @close="openColorsDialog = false"
                  popover-to="left"
                  row-length="6"
                  show-border
                  :colors="colors"
                />
              </v-layout>
              <v-layout row justify-space-between class="mt-5" align-center>
                <span style="margin-right: 15px">Change width</span>
                <v-slider
                  style="margin-top: 0"
                  class="dutch-slider"
                  v-model="zoomBlock"
                  max="1992"
                  min="220"
                  always-dirty
                  :thumb-size="38"
                  thumb-label="always"
                  append-icon="add"
                  prepend-icon="remove"
                  @click:append="zoomBlockUp"
                  @click:prepend="zoomBlockDown"
                >
                  <template slot="thumb-label" slot-scope="props">
                    <div style="font-size: 11px">{{ props.value }}px</div>
                  </template>
                </v-slider>
              </v-layout>
              <br />
              <v-layout row justify-space-between align-center>
                <div></div>
                <v-btn @click="setDefaultColors" color="info">Set Default View</v-btn>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green lighten-3"
                @click="
                  openColorsDialog = false;
                  changeColors = false;
                "
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-list>
  </v-card>
</template>

<script>
import Swatches from 'vue-swatches';
import 'vue-swatches/dist/vue-swatches.min.css';
import { mapMutations } from 'vuex';

export default {
  name: 'Profile',
  data() {
    return {
      showErrors: false,
      dialogBilling: false,
      changePassword: false,
      openColorsDialog: false,
      headerTitleColor: '',
      zoomBlock: 420,
      buttonColor: '#B3672B',
      color: '#dcdcdc',
      backgroundForTiming: 'grey',
      colors: [
        ['#dcdcdc', '#BDBDBD', '#CFD8DC', '#B0BEC5', '#ffffff'],
        ['#D7CCC8', '#FFF3E0', '#DCEDC8', '#F1F8E9', '#B2DFDB'],
        ['#BBDEFB', '#b7faf4', '#96f0ea', '#b9f5f1', '#dcfaf8'],
        ['#C8E6C9', '#FFEBEE', '#FFF8E1', '#9E9E9E', '#757575'],
        ['#FDA50f', '#FD6A02', '#B3672B', '#8B4000', '#FF7417'],
      ],
      changeColors: false,
    };
  },
  components: {
    Swatches,
  },
  methods: {
    ...mapMutations([
      'setWidgetBackgroundColor',
      'setWidgetTimingBackground',
      'setWidgetHeaderTitleColor',
      'setWidgetButtonColor',
      'setWidgetZoomBlock',
    ]),
    setDefaultColors() {
      this.setWidgetBackgroundColor('#dcdcdc');
      this.color = '#dcdcdc';
      this.setWidgetTimingBackground('grey');
      this.backgroundForTiming = 'grey';
      this.setWidgetHeaderTitleColor('green');
      this.headerTitleColor = 'green';
      this.setWidgetButtonColor('#B3672B');
      this.buttonColor = '#B3672B';
      this.setWidgetZoomBlock('420px');
      this.zoomBlock = '420';
    },
    saveColors() {
      this.setWidgetTimingBackground(this.backgroundForTiming);
      this.setWidgetBackgroundColor(this.color);
      this.setWidgetHeaderTitleColor(this.headerTitleColor);
      this.setWidgetZoomBlock(this.zoomBlock + 'px');
      this.setWidgetButtonColor(this.buttonColor);
    },
    zoomBlockUp() {
      this.zoomBlock = this.zoomBlock + 1;
    },
    zoomBlockDown() {
      this.zoomBlock = this.zoomBlock - 1;
    },
  },
  watch: {
    zoomBlock() {
      this.$nextTick(() => this.saveColors());
    },
  },
};
</script>

<style>
.widget-customize .vue-swatches__container {
  max-height: 200px !important;
}
</style>
